import {
    MdAddCircleOutline,
    MdCalendarToday,
    MdOutlineArticle,
    MdOutlineBalance,
    MdOutlineGroup,
    MdOutlineSettingsSuggest,
    MdOutlineWorkOutline,
    MdPersonOutline,
} from 'react-icons/md';

const ecbaNavigation = [
    {
        id: 'ecba-referrals',
        title: 'Referrals',
        icon: <MdOutlineGroup size={20} />,
        navLink: '/agent_us_referrals',
        action: 'read',
        resource: 'ecba-referrals',
    },
    {
        id: 'ecba-leads',
        title: 'Leads',
        icon: <MdAddCircleOutline size={20} />,
        navLink: '/agent_us_leads',
        action: 'read',
        resource: 'ecba-referrals',
    },
    {
        id: 'ecba-matters',
        title: 'Matters',
        icon: <MdOutlineWorkOutline size={20} />,
        navLink: '/agent_us_matters',
        action: 'read',
        resource: 'ecba-referrals',
    },
    {
        id: 'matter_agent_appointments',
        title: 'Appointments',
        icon: <MdCalendarToday size={20} />,
        navLink: '/agent_appointments',
        action: 'read',
        resource: 'matter_agent_appointments',
    },
    {
        id: 'ecba-lawyers',
        title: 'Lawyers',
        type: 'item',
        icon: <MdOutlineBalance size={20} />,
        navLink: '/agent_us_lawyers',
        action: 'read',
        resource: 'ecba_lawyers',
    },
    {
        id: 'ecba-clients',
        title: 'Contacts',
        type: 'item',
        icon: <MdPersonOutline size={20} />,
        navLink: '/agent_us_contacts',
        action: 'read',
        resource: 'ecba_clients',
    },
    {
        id: 'ecba_reports',
        title: 'Reports',
        type: 'item',
        icon: <MdOutlineArticle size={20} />,
        navLink: '/agent_us_reports',
        action: 'read',
        resource: 'ecba_reports',
    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'item',
        icon: <MdOutlineSettingsSuggest size={20} />,
        navLink: '/agent_settings',
        action: 'read',
        resource: 'agent_settings',
    },
];

export default ecbaNavigation;
